import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useFetchItems from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import { getAllColumns } from "./AllColumnsData";
import { Table } from "antd";
import useFetchContacts from "../../../disaster/hooks/useFetchContacts";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useUploadDocument from "../../../disaster/hooks/useUploadDocument";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import FETCH from "../../../../../utils/fetch";
const MODULE_NAMES = [
  // "Assets Documentation",
  "Financial Accounts Information",
  "Real Estate Information",
  "Vehicle Information Divorce",
  "Personal Property Information",
];

export default function AssetDocumentation() {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [assetsList, setAssetsList] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Asset Documentation");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const { fetchData, formatModuleKey, setTableData, setToUpdate, tableData } =
    useFetchItems(MODULE_NAMES, setLoading);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { attributes } = useGetAttributes(MODULE_NAMES, setLoading);
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { contactList } = useFetchContacts(setLoading);
  const { handleImageUpload } = useUploadDocument(setLoading, setFormData);
  const getLiabilitesList = async () => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liabilities and Credit&page=1&limit=50&clientId=${ID}`
            : `?module=Liabilities and Credit&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        datares.records.map((item) => {
          if (item.subType == "Credit") {
            item["Nickname of Liabilities"] = item["Nickname of Credit"];
            item["Initial Loan Amount"] = item["Credit Balance"];
            item["Interest Rate"] = item["Interest Rate (or APR%)"];
            item["Maturity Date"] = item["Point Expiration"];
            item["Name of Financial Institution"] = item["Name of Issuer"];
            item["Monthly Payment"] =
              item["Monthly Payment"] && item["Monthly Payment"].toString();
            item["Start Date"] = new Date();
            item["subType"] = item.subType;
          }
        });
        setLiabilitesCredit(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAssetsList = async () => {
    try {
      setLoading(true);

      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Asset&page=1&limit=10&clientId=${ID}`
            : `?module=Asset&page=1&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setAssetsList(datares.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );

  // const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const tableDataObj = {
    // "Asset Documentation":tableData.assetsDocumentationData,
    "Financial Accounts Information":
      tableData.financialAccountsInformationData,
    "Real Estate Information": tableData.realEstateInformationData,
    "Vehicle Information Divorce": tableData.vehicleInformationDivorceData,
    "Personal Property Information": tableData.personalPropertyInformationData,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleItemsInfoSelect = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  console.log("Table Data", tableData);
  useEffect(() => {
    getLiabilitesList();
    getAssetsList();
  }, []);

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  const financialTables = [
    {
      title: "Financial Accounts Information",
      key: 1,
      moduleName: "Financial Accounts Information",
    },
  ];

  const propertyTables = [
    {
      title: "Real Estate Information",
      key: 2,
      moduleName: "Real Estate Information",
    },
    {
      title: "Vehicle Information",
      key: 3,
      moduleName: "Vehicle Information Divorce",
    },
    {
      title: "Personal Property Information",
      key: 4,
      moduleName: "Personal Property Information",
    },
  ];

  const AddDocument = () => {
    history.push("/organizer/important-document");
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div
          style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}
        >
          <h2 className="parent-title">Asset Documentation</h2>
          <ToolTipCreator name={"Divorce_Asset_Documentation"} />
        </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>

      <div className="child-title-container">
        <h2 className="child-title">Financial Documents</h2>
      </div>

      {financialTables.map((table) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          onClick={() => showModal(table.title)}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <div className="child-title-container">
        <h2 className="child-title">Property</h2>
      </div>

      {propertyTables.map((table) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          onClick={() => showModal(table.moduleName)}
        >
          <Table
            columns={AllColumnsData[table.moduleName]}
            dataSource={tableDataObj[table.moduleName]}
          />
        </CollapseableTable>
      ))}

      <CustomModal
        show={isModalVisible}
        fields={attributesData}
        modalTitle={modalTitle}
        dropdownOptionsLiabilites={liabilitiesCredit && liabilitiesCredit}
        dropdownOptionsAssets={assetsList && assetsList}
        close={handelCloseModal}
        onChange={handleChange}
        onSelectChange={handleItemsInfoSelect}
        setFormData={setFormData}
        submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
        selectedRowData={formData}
        handleItemsInfoImageChange={formData}
        loading={loading}
      />
      <NewLoader isLoading={loading} />
    </div>
  );
}
